import { lazy } from 'react';

export const VocabularyDashboardPage = lazy(() => import('./VocabularyDashboardPage'));
